import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { UpdateAttendanceSettingMutationVariables } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Select'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import AttendanceSettings from 'modules/attendance/store/collections/settings'

type EmployeeAccessSearchFieldProps = {
  policyForm: FormikProps<UpdateAttendanceSettingMutationVariables>
  updatePolicy: () => void
}

const EmployeeAccessSearchField = ({
  policyForm,
  updatePolicy,
}: EmployeeAccessSearchFieldProps) => {
  const [employeeAccessSearchFieldOptions, setEmployeeAccessSearchFieldOptions] =
    React.useState<[{ label: string; value: string; default: boolean }]>()
  const { loading } = useAsyncData(() => {
    return AttendanceSettings.fetchEmployeeAccessSearchFieldOptions().then((options) =>
      setEmployeeAccessSearchFieldOptions(options.options)
    )
  }, [])

  const onChange = (value: string) => {
    policyForm.setFieldValue('employeeAccessSearchField', value)
    updatePolicy()
  }

  if (loading) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Spinner />
      </Box>
    )
  }

  return (
    <Select
      label={i18n.t('time_tracking.settings.form.toggle.employee_access_search_field.label')}
      value={policyForm.values.employeeAccessSearchField ?? ''}
      options={employeeAccessSearchFieldOptions ? employeeAccessSearchFieldOptions : []}
      onChange={onChange}
    />
  )
}

export default observer(EmployeeAccessSearchField)
